import { createAction } from '@reduxjs/toolkit';

const FETCH_USER_PREFERENCES = 'FETCH_USER_PREFERENCES';
const fetchUserPreferences = createAction(FETCH_USER_PREFERENCES);

// eslint-disable-next-line import/prefer-default-export
export { fetchUserPreferences };
